<mat-chip-grid #codesChipGrid>
  <mat-chip-row
    *ngFor="let code of value"
    (removed)="removeCode(code)"
    [removable]="true"
  >
    {{ code }}
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip-row>

  <input
    [matChipInputFor]="codesChipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputAddOnBlur]="true"
    (input)="onInputChange($event)"
    (matChipInputTokenEnd)="addCode($event)"
  />
</mat-chip-grid>

<div
  *ngIf="feedback"
  class="mt-1 text-xs"
  [class.text-warn]="feedback.kind === 'error'"
  role="status"
  aria-live="polite"
>
  {{ feedback.token | translate: feedback.params }}
</div>

<div *ngIf="value.length > 1" class="mt-4">
  <button mat-flat-button type="button" class="btn-sm" (click)="removeAllCodes()">
    {{ 'common.remove-all' | translate }}
  </button>
  <button mat-flat-button type="button" class="btn-sm" (click)="copyCodes()">
    {{ 'common.copy' | translate }}
  </button>
</div>
